export enum NotificationCategory {
  ALL = "all",
  CANDIDATES = "candidates",
  TASKS = "tasks",
}
